<template>
  <div class="detailBox">
    <ul class="detailContent">
      <el-form
        :model="state.model"
        label-width="120px"
        :scroll-to-error="true"
        ref="formDom"
        inline
        style="position: relative"
      >
        <el-form-item
          label="状态"
          prop="IsQy"
          :rules="[
            { required: true, message: '请选择角色状态', trigger: 'blur' },
          ]"
        >
          <el-switch
            v-model="state.model.IsQy"
            inline-prompt
            active-text="可售"
            inactive-text="停用"
          />
        </el-form-item>
        <el-form-item
          label="供应商"
          prop="GysId"
          :rules="[
            { required: true, message: '请选择供应商', trigger: 'blur' },
          ]"
          style="flex: 1; margin-right: 0"
        >
          <el-select
            v-model="state.model.GysId"
            placeholder="--请选择供应商--"
            value-key="Mc"
            :disabled="!Array.isArray(state.gysData)"
          >
            <el-option
              v-for="item in state.gysData"
              :key="item.Id"
              :label="item.Mc"
              :value="item.Id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="酒店名称"
          prop="Mc"
          :rules="[
            { required: true, message: '请输入酒店名称', trigger: 'blur' },
          ]"
          style="width: 100%"
        >
          <el-input v-model="state.model.Mc" />
        </el-form-item>
        <el-form-item
          label="星级"
          prop="Xj"
          :rules="[
            { required: true, message: '请选择星级', trigger: 'blur' },
          ]"
          style="width: 30%"
        >
          <el-select v-model="state.model.Xj" placeholder="--请选择星级--">
            <el-option label="三星" value="三星" />
            <el-option label="四星" value="四星" />
            <el-option label="五星" value="五星" />
            <el-option label="经济型" value="经济型" />
          </el-select>
        </el-form-item>
        <el-form-item
          label="联系电话"
          prop="Dh"
          :rules="[
            { required: true, message: '请输入联系电话', trigger: 'blur' },
          ]"
          style="width: 30%; margin-right: 0"
        >
          <el-input v-model="state.model.Dh" />
        </el-form-item>
        <el-form-item
          label="房间数"
          prop="Fjs"
          :rules="[
            { required: true, message: '请输入房间数', trigger: 'blur' },
          ]"
          style="width: 30%; margin-right: 0"
        >
          <el-input-number v-model="state.model.Fjs" :min="1" controls-position="right" style="width: 100%" />
        </el-form-item>
        <el-form-item label="地址" style="width: 100%">
          <el-input v-model="state.model.Dz" />
        </el-form-item>
        <el-form-item
          label="经度"
          prop="Jd"
          style="width: 30%"
        >
          <el-input v-model="state.model.Jd" placeholder="例如: 116.404" />
        </el-form-item>
        <el-form-item
          label="纬度"
          prop="Wd"
          style="width: 30%; margin-right: 0"
        >
          <el-input v-model="state.model.Wd" placeholder="例如: 39.915" />
        </el-form-item>
        <el-form-item style="width: 30%; margin-right: 0">
          <el-button type="text" @click="openMapModal()" style="padding: 0; color: #007bff">
            🗺️ 坐标拾取
          </el-button>
        </el-form-item>
        <el-form-item
          label="早餐"
          prop="Zc"
          style="width: 30%; margin-right: 0"
        >
          <el-select v-model="state.model.Zc" placeholder="--请选择--">
            <el-option label="无" value="无" />
            <el-option label="含早" value="含早" />
            <el-option label="单早" value="单早" />
            <el-option label="双早" value="双早" />
          </el-select>
        </el-form-item>
        <el-form-item label="酒店设施" style="width: 100%">
          <el-checkbox-group v-model="state.model.Ss">
            <el-checkbox label="WiFi" />
            <el-checkbox label="停车场" />
            <el-checkbox label="健身房" />
            <el-checkbox label="游泳池" />
            <el-checkbox label="会议室" />
            <el-checkbox label="餐厅" />
            <el-checkbox label="商务中心" />
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="入住时间"
          prop="Rzsj"
          style="width: 30%"
        >
          <el-time-picker
            v-model="state.model.Rzsj"
            format="HH:mm"
            value-format="HH:mm"
            placeholder="选择时间"
          />
        </el-form-item>
        <el-form-item
          label="退房时间"
          prop="Tfsj"
          style="width: 30%; margin-right: 0"
        >
          <el-time-picker
            v-model="state.model.Tfsj"
            format="HH:mm"
            value-format="HH:mm"
            placeholder="选择时间"
          />
        </el-form-item>
        <el-form-item label="可预订日期范围" style="width: 30%; margin-right: 0">
          <el-date-picker
            v-model="state.model.Kydyrq"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="酒店简介" style="width: 100%">
          <el-input
            type="textarea"
            v-model="state.model.Jj"
            :autosize="{ minRows: 2 }"
          />
        </el-form-item>
        <el-form-item label="预订须知" style="width: 100%">
          <el-input
            type="textarea"
            v-model="state.model.Ydxz"
            :autosize="{ minRows: 2 }"
          />
        </el-form-item>

        <el-form-item label="是否预约" prop="IsYuyue" style="width: 30%">
          <el-switch
            v-model="state.model.IsYuyue"
            inline-prompt
            active-text="需要"
            inactive-text="不需要"
          />
        </el-form-item>
        <el-form-item
          v-if="state.model.IsYuyue"
          label="提前天数"
          prop="YuyueTianShu"
          style="width: 30%; margin-right: 0"
        >
          <el-input-number
            v-model="state.model.YuyueTianShu"
            :min="1"
            controls-position="right"
            style="width: 100%"
            placeholder="请指定天数"
          />
        </el-form-item>

        <el-form-item
          label="核销码类型"
          prop="HeXiaoMaLeiXing"
          style="width: 30%; margin-right: 0"
        >
          <el-select
            v-model="state.model.HeXiaoMaLeiXing"
            placeholder="请选择"
          >
            <el-option label="无" :value="0" />
            <el-option label="系统自动码" :value="1" />
          </el-select>
        </el-form-item>

        <!-- 酒店图片 -->
        <el-form-item label="酒店图片" style="width: 100%; display: flex; align-items: flex-start">
          <div style="display: flex; flex-wrap: wrap; gap: 10px">
            <div
              v-for="(tp, index) in state.model.Tps"
              :key="tp"
              :style="{
                marginTop: '10px',
                marginRight: '10px',
                borderRadius: '5px',
                overflow: 'hidden',
                position: 'relative',
                border: state.model.Fm === tp ? '3px solid #409eff' : '3px solid transparent',
                boxSizing: 'border-box'
              }"
              class="uploadTpBox"
            >
              <img class="uploadTp" :src="getImageUrl(tp)" referrerpolicy="no-referrer" />
              <div style="text-align: center; padding: 8px; background: #f5f7fa;">
                <el-radio-group
                  v-model="state.model.Fm"
                  style="display: flex; justify-content: center;"
                >
                  <el-radio :label="tp" size="small">设为封面</el-radio>
                </el-radio-group>
              </div>
              <div class="uploadDel">
                <el-icon
                  size="30"
                  style="margin: auto; cursor: pointer"
                  @click="onDelTp(index)"
                  ><Delete
                /></el-icon>
              </div>
            </div>
          </div>
          <el-upload
            :show-file-list="false"
            :auto-upload="false"
            :multiple="true"
            accept=".jpeg,.jpg,.png,.gif"
            :on-change="onUploadChange"
            style="marginLeft: '10px'"
          >
            <template #trigger>
              <div class="uploadAdd">
                <el-icon size="30" style="margin: auto; cursor: pointer"
                  ><Plus
                /></el-icon>
              </div>
            </template>
          </el-upload>
        </el-form-item>
      </el-form>
    </ul>
    <ul class="detailBtn">
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from "vue";
import { Delete, Plus } from "@element-plus/icons-vue";
import {
  jiudian_add,
  jiudian_edit,
  jiudian_detail,
  jiudian_uploadtp,
  gongyingshang_select,
  home_uploadconfig,
} from "@/http/api";
import $http from "@/http/index";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const formDom = ref(null);
    const state = reactive({
      model: {
        IsQy: true,
        Ss: [],
        Xj: "",
        Zc: "无",
        Tps: [],
        HeXiaoMaLeiXing: 0,
        SupplierGoodsId: "",
      },
      imageBaseUrl: "",
    });
    onMounted(() => {
      loadUploadConfig();
      loadGys();

      if (props.id) {
        jiudian_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data;
            if (typeof state.model.Ss === 'string') {
              state.model.Ss = state.model.Ss.split(',');
            }
            if (typeof state.model.Kydyrq === 'string') {
              state.model.Kydyrq = state.model.Kydyrq ? state.model.Kydyrq.split(',') : [];
            }
            // Tps 可能是 JSON 字符串
            if (typeof state.model.Tps === 'string') {
              try {
                state.model.Tps = JSON.parse(state.model.Tps);
              } catch {
                state.model.Tps = [];
              }
            }
            if (!state.model.Tps) state.model.Tps = [];
          }
        });
      }
    });

    onUnmounted(() => {
      delete window.handleMapSelect;
      delete window.closeMapModal;
      if (window.mapModal) {
        window.mapModal.close();
        window.mapModal = null;
      }
    });

    //加载供应商下拉数据
    const loadGys = () => {
      gongyingshang_select().then((res) => {
        if (res.status == 200) state.gysData = res.data;
      });
    };

    //加载上传配置（OSS/本地）
    const loadUploadConfig = () => {
      home_uploadconfig().then((res) => {
        if (res.status == 200) {
          const config = res.data;
          if (config.useOss && config.ossBaseUrl) {
            state.imageBaseUrl = config.ossBaseUrl;
          } else {
            state.imageBaseUrl = $http.defaults.baseURL;
          }
        }
      }).catch(() => {
        state.imageBaseUrl = $http.defaults.baseURL;
      });
    };

    //生成图片完整URL
    const getImageUrl = (tp) => {
      if (!tp) return "";
      const url = String(tp).trim();
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
      }
      if (state.imageBaseUrl) {
        return state.imageBaseUrl + url;
      }
      return $http.defaults.baseURL + url;
    };

    //上传图片
    const onUploadChange = (file) => {
      let formData = new FormData();
      formData.append("files", file.raw);
      jiudian_uploadtp(formData).then((res) => {
        if (res.status == 200) {
          state.model.Tps = [...state.model.Tps, ...res.data];
          if (!state.model.Fm) state.model.Fm = state.model.Tps[0];
        }
      });
    };

    //删除图片
    const onDelTp = (index) => {
      state.model.Tps.splice(index, 1);
      if (state.model.Fm) {
        if (state.model.Tps?.length > 0) {
          if (!state.model.Tps.includes(state.model.Fm)) {
            state.model.Fm = state.model.Tps[0];
          }
        } else {
          delete state.model.Fm;
        }
      }
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (!valid) return false;

        const submitData = { ...state.model };
        if (Array.isArray(submitData.Ss)) {
          submitData.Ss = submitData.Ss.join(',');
        }
        if (Array.isArray(submitData.Kydyrq)) {
          submitData.Kydyrq = submitData.Kydyrq.join(',');
        }

        if (props.id) {
          jiudian_edit(submitData).then((res) => {
            proxy.$post_response(res, emit);
          });
        } else {
          jiudian_add(submitData).then((res) => {
            proxy.$post_response(res, emit);
          });
        }
      });
    };

    const openMapModal = () => {
      const lng = state.model.Jd || 117.251091;
      const lat = state.model.Wd || 31.517890;
      const url = `/map_picker.html?lng=${lng}&lat=${lat}`;
      
      const modalWidth = 850;
      const modalHeight = 680;
      const left = (window.screen.width - modalWidth) / 2;
      const top = (window.screen.height - modalHeight) / 2;
      
      window.mapModal = window.open(
        url,
        '_blank',
        `width=${modalWidth},height=${modalHeight},left=${left},top=${top},toolbar=no,scrollbars=no,resizable=yes`
      );
      
      window.handleMapSelect = (data) => {
        state.model.Jd = data.lng;
        state.model.Wd = data.lat;
        if (data.address) {
          state.model.Dz = data.address;
        }
        if (window.mapModal) {
          window.mapModal.close();
          window.mapModal = null;
        }
      };
      
      window.closeMapModal = () => {
        if (window.mapModal) {
          window.mapModal.close();
          window.mapModal = null;
        }
      };
    };

    return {
      state,
      formDom,
      onSubmit,
      openMapModal,
      onUploadChange,
      onDelTp,
      getImageUrl,
      Delete,
      Plus,
    };
  },
};
</script>
<style scoped>
.uploadAdd {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  border-radius: 5px;
  border: 1px dashed #e2e2e2;
  display: flex;
  color: #a2a2a2;
}
.uploadAdd:hover {
  background-color: rgba(100, 100, 100, 0.2) !important;
  color: #fff !important;
}

.uploadDel {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  color: #fff;
  display: none;
}

.uploadTp {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}

.uploadTpBox:hover .uploadDel {
  display: flex !important;
}
</style>